<template>
    <div>
        <div class="weui-cells__title">修改真实姓名</div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd">
                    <label class="weui-label">真实姓名</label>
                </div>
                <div class="weui-cell__bd">
                    <input class="weui-input" v-model="userInfo.realname" placeholder="请输入真实姓名" style="text-align: right;" />
                </div>
            </div>
        </div>

        <div class="warehousing-footer-item sureinwarehousing" style="flex:2" @click="save">
            <a href="javascript:;">提 交</a>
        </div>
    </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";

export default {
  data() {
    return {
      encodeToken: "",
      token: "",
      userInfo: {}
    };
  },
  created() {
    let that = this;
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then(response => {
        that.userInfo = response.data.data;
      })
      .catch(error => {
        weui.topTips("获取用户信息失败", 2000);
      });
  },
  methods: {
    save() {
      let that = this;
      if (!this.userInfo.realname) {
        weui.alert("真实姓名不能为空");
        return;
      } else {
        axios
          .put("/api/user/updateRealname", { realname: this.userInfo.realname })
          .then(res => {
            if (res.data.success) {
              weui.toast("保存成功", 1000);
              // 跳转回个人中心页面
              that.$router.push("/userInfo/express/" + that.encodeToken);
            } else {
              weui.alert(res.data.message);
            }
          })
          .catch(err => {
            weui.alert("保存失败");
          });
      }
    }
  }
};
</script>

<style scoped>
.warehousing-footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  background-color: #1aad19;
  margin-top: 10px;
  line-height: 50px;
}
.warehousing-footer-item a {
  color: #ffffff;
}
</style>





// WEBPACK FOOTER //
// src/components/userinfos/RealnameEdit.vue